export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfgTcB1Adzryhs7_PimXmhDM_sJKW398W1idXHjHcwPWrWsVA/viewform";
